import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resetGeoChecklist } from '../../../services/geo-checklist/GeoChecklistService';
import { GET_GEO_CHECKLIST } from '../../query/geo-checklist/keys';

interface ResetGeoChecklistParams {
  projectId: number;
  checklistType: 'TOPICS_PROMPTS' | 'AI_VISIBILITY';
}

export const useResetGeoChecklist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, checklistType }: ResetGeoChecklistParams) =>
      resetGeoChecklist(projectId, checklistType),

    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: [GET_GEO_CHECKLIST, projectId] });
    },
  });
};
